<script> 
 
export default {
  data() {
    return {};
  },
  props: {
    loading: Boolean,
  },
  methods:{
    loaderclose(){
      var preloader = document.getElementsByClassName("preloader-component");
            Array.prototype.forEach.call(preloader, function(el) {
                el.style.display = "none";
            }); 
            var status = document.getElementsByClassName("status");
            Array.prototype.forEach.call(status, function(el) {
                el.style.display = "none";
            });
    },
    loaderopen(){
      var preloader = document.getElementsByClassName("preloader-component");
            Array.prototype.forEach.call(preloader, function(el) {
                el.style.display = "block";
            }); 
            var status = document.getElementsByClassName("status");
            Array.prototype.forEach.call(status, function(el) {
                el.style.display = "block";
            });
    } 
  }, 
  watch: {
    loading() {  
      if(this.loading == false){
        this.loaderclose()
      }
      if(this.loading == true){
        this.loaderopen()
      }
    },
  },
};
</script>

<template> 
  <div :class="{ 'is-loading': loading }">
    <div class="preloader-component">
      <div class="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>
